function Testimonials() {
    return (
        <section id="testimonials" className="section">
      <div className="container">
        <div className="section-head reveal">
          <h2>Depoimentos</h2>
          <p>Alguns relatos de clientes sobre nossa forma de atender e conduzir as rotinas contábeis.</p>
        </div>

        <div className="testimonial-shell reveal">
          <button className="t-nav" id="tPrev" aria-label="Depoimento anterior">‹</button>

          <div className="testimonial-track" id="testimonialTrack" aria-live="polite">
            <article className="testimonial">
              <div className="stars" aria-label="5 estrelas">★★★★★</div>
              <p>“Equipe muito organizada. Tiraram nossas dúvidas, ajustaram processos e hoje temos mais clareza dos números.”</p>
              <div className="t-meta">
                <div className="avatar" aria-hidden="true">AR</div>
                <div>
                  <strong>Ana R.</strong>
                  <span>Comércio</span>
                </div>
              </div>
            </article>

            <article className="testimonial">
              <div className="stars" aria-label="5 estrelas">★★★★★</div>
              <p>“O planejamento tributário fez diferença. Atendimento rápido, linguagem simples e orientações práticas.”</p>
              <div className="t-meta">
                <div className="avatar" aria-hidden="true">CM</div>
                <div>
                  <strong>Carlos M.</strong>
                  <span>Prestador de serviços</span>
                </div>
              </div>
            </article>

            <article className="testimonial">
              <div className="stars" aria-label="5 estrelas">★★★★★</div>
              <p>“Com o suporte do DP e do fiscal, ficamos tranquilos com prazos e mudanças na legislação. Recomendo!”</p>
              <div className="t-meta">
                <div className="avatar" aria-hidden="true">LP</div>
                <div>
                  <strong>Larissa P.</strong>
                  <span>Indústria</span>
                </div>
              </div>
            </article>
          </div>

          <button className="t-nav" id="tNext" aria-label="Próximo depoimento">›</button>
        </div>

        <div className="dots" id="testimonialDots" aria-label="Navegação de depoimentos"></div>
      </div>
    </section>
    );
}

export default Testimonials;